/**
 * An old Son of Basel portal address that reached the router: sent on to its
 * Operator page with its query and hash, or Page not found when it names no
 * page the portal drew.
 *
 * A page load of one is meant to be answered by the API with a 308 first. This
 * is for a link inside the app that still names one (a meeting link quoted in
 * an older message in the inbox, a handbook line) and for any load the API
 * did not answer. Both read the one table in `@gojibasel/shared/operator-paths`,
 * so they cannot disagree. Built like `LegacyProspectingRedirect`.
 *
 * It lives here rather than in pages/operator/shared because that folder is
 * the Operator frame's, and this is a piece of the route table.
 *
 * Always `replace`, so Back does not return to an address that only bounces.
 */
import { Navigate, useLocation } from 'react-router-dom'
import { legacyOperatorTarget } from '@gojibasel/shared/operator-paths'
import NotFound from '../pages/NotFound'

/** Where an old portal address lands inside the app, hash included, or null. */
export function legacyOperatorLanding(location: { pathname: string; search: string; hash: string }): string | null {
  const target = legacyOperatorTarget(location.pathname, location.search)
  return target === null ? null : `${target}${location.hash}`
}

export function LegacyOperatorRedirect() {
  const location = useLocation()
  const target = legacyOperatorLanding(location)
  return target === null ? <NotFound /> : <Navigate to={target} replace />
}
